import { ListingPictureKind, MediaV3 } from '@kouto/types';

const getMapMedia = (medias: MediaV3[]): MediaV3 | undefined => {
  return medias.find((media) => media.kind === ListingPictureKind.MAP);
};

export default getMapMedia;
